import apiClient from './api'

export type CredentialState = 'VALID' | 'EXPIRING' | 'EXPIRED' | 'MISSING' | 'NO_EXPIRY'
export type Light = 'GREEN' | 'AMBER' | 'RED'

export const STATE_LABEL: Record<CredentialState, string> = {
    VALID: 'Vigente', EXPIRING: 'Por vencer', EXPIRED: 'Vencida', MISSING: 'Falta', NO_EXPIRY: 'Sin vencimiento',
}
export const LIGHT_LABEL: Record<Light, string> = { GREEN: 'Al día', AMBER: 'Por vencer', RED: 'Pendiente' }

export interface CredentialType {
    id: number
    code: string
    name: string
    description: string | null
    validityMonths: number | null
    required: boolean
    active: boolean
}

export interface TypeInput {
    code?: string
    name?: string
    description?: string
    validityMonths?: number | null
    required?: boolean
    active?: boolean
}

export interface CredentialView {
    id: number | null
    typeId: number
    typeCode: string
    typeName: string
    required: boolean
    issuedAt: string | null
    expiresAt: string | null
    documentRef: string | null
    note: string | null
    state: CredentialState
    daysLeft: number | null
}

export interface PersonView {
    userId: string
    fullName: string
    username: string
    light: Light
    requiredTotal: number
    requiredValid: number
    credentials: CredentialView[]
}

export interface CredentialInput {
    typeId: number
    issuedAt: string
    expiresAt?: string
    documentRef?: string
    note?: string
}

export interface ExpiringItem {
    userId: string
    fullName: string
    typeName: string
    required: boolean
    expiresAt: string
    daysLeft: number
}

const BASE = '/api/v1/credentials'

export const credentialService = {
    types: () => apiClient.get<CredentialType[]>(`${BASE}/types`).then((r) => r.data),
    createType: (in_: TypeInput) => apiClient.post<CredentialType>(`${BASE}/types`, in_).then((r) => r.data),
    updateType: (id: number, in_: TypeInput) => apiClient.put<CredentialType>(`${BASE}/types/${id}`, in_).then((r) => r.data),
    overview: () => apiClient.get<PersonView[]>(`${BASE}/overview`).then((r) => r.data),
    expiring: (days = 30) => apiClient.get<ExpiringItem[]>(`${BASE}/expiring`, { params: { days } }).then((r) => r.data),
    person: (userId: string) => apiClient.get<PersonView>(`${BASE}/users/${userId}`).then((r) => r.data),
    add: (userId: string, in_: CredentialInput) => apiClient.post(`${BASE}/users/${userId}`, in_).then((r) => r.data),
    remove: (userId: string, id: number) => apiClient.delete(`${BASE}/users/${userId}/${id}`),
}
